<!--
 * @Descripttion: 
 * @version: 
 * @Author: pengmiaopei
 * @Date: 2021-07-24 15:21:44
 * @LastEditors: gengningning
 * @LastEditTime: 2021-11-15 17:00:04
 * @Description: file content
 * @FilePath: \Design_Vue_pmp\src\components\BimTable\index.vue
-->

<template>
  <div class="head-container">
    <!-- 顶部搜索区域 -->
    <transition name="el-zoom-in-top">
      <el-form v-show="flag" ref="hForm" inline :model="headerForm">
        <el-form-item v-for="(item, index) in formConfig" :key="index" :label="item.label">
          <el-input
            v-if="item.type === 'input'"
            v-model="headerForm[item.model]"
            :placeholder="item.placeholder || '请输入'"
            width="100px"
          />
          <el-date-picker
            v-else-if="item.type === 'daterange'"
            v-model="headerForm[item.model]"
            type="daterange"
            range-separator="到"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            width="100px"
          />
          <el-select v-else v-model="headerForm[item.model]" :placeholder="item.placeholder || '请选择'">
            <el-option v-for="(k, i) in item.list" :key="i" :label="k.label" :value="k.value" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="formConfig.length">
          <el-button type="primary" icon="el-icon-search" @click="headFormSearch">
            查询
          </el-button>
          <el-button v-debounce="headFormReset" type="warning" icon="el-icon-refresh">
            重置
          </el-button>
        </el-form-item>
      </el-form>
    </transition>
    <!-- 表格上方操作区域 -->
    <transition name="el-zoom-in-bottom">
      <div class="crud-opts">
        <span class="crud-opts-left">
          <el-button
            v-for="(btn, index) in btnList"
            :key="index"
            class="filter-item"
            size="mini"
            :type="btn.type"
            :icon="btn.icon"
            @click="toolsBtn(btn.type)"
          >
            {{ btn.name }}
          </el-button>
        </span>
        <el-button-group class="crud-opts-right">
          <el-button v-if="formConfig.length && tableLeftBtn.length" size="mini" icon="el-icon-search" @click="flag = !flag" />
          <!-- <el-button v-debounce="headFormReset" size="mini" icon="el-icon-refresh" /> -->
        </el-button-group>
      </div>
    </transition>
    <!-- 表格区域 -->
    <!-- 一定要有row-key的id值 -->
    <el-table
      ref="multipleTable"
      default-expand-all
      :data="tableData"
      style="width: 100%"
      highlight-current-row
      border
      :height="total === 0 ? height + 50 : height"
      :max-height="total === 0 ? height + 50 : height"
      row-key="id"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      :default-sort="{ prop: 'sort', order: 'ascending' }"
      @select-all="selectAll"
      @select="selectChange"
      @row-click="rowTapClick"
      @row-dblclick="rowDBClick"
      @current-change="radioClickChange"
    >
      <!-- 多选框 -->
      <el-table-column v-if="checkBoxFlag" type="selection" width="55" />
      <!-- 单选选框 -->
      <el-table-column v-if="radioFlag" label="选择" width="55">
        <template slot-scope="scope">
          <el-radio v-model="tableRadio" :label="scope.row"><i></i></el-radio>
        </template>
      </el-table-column>
      <el-table-column width="55" type="index" label="#" align="center" />
      <el-table-column
        v-for="(item, i) in tableHeader"
        :key="i"
        :label="item.name"
        :align="item.align || 'center'"
        :width="item.width"
        :sortable="item.sortable"
        :prop="item.key"
      >
        <template slot-scope="{ row }">
          <el-tag v-if="item.custom" :type="row[item.key].type" :effect="item.effect">
            {{ row[item.key].value }}
          </el-tag>
          <span v-else>{{ row[item.key] }}</span>
        </template>
      </el-table-column>
      <!-- 表格行内按钮 -->
      <el-table-column v-if="tableBtn.length" label="操作" align="center" :width="tableBtn.length * 50" fixed="right">
        <template slot-scope="{ row }">
          <el-button
            v-for="(tbtn, index) in tableBtnList"
            :key="index"
            :type="tbtn.type"
            :icon="tbtn.icon"
            circle
            @click="rowClick(row, tbtn.type)"
          />
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页区域 -->
    <el-pagination
      v-if="total"
      :current-page="currentPage"
      :layout="layout"
      :page-sizes="[15, 30, 45, 60]"
      :page-size="pageSize"
      :total="total"
      background
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
  </div>
</template>

<script>
  import { btnFilter } from '@/utils/filter'
  export default {
    name: 'BimTable',
    filters: {},
    props: {
      //@ 顶部搜索栏参数
      formConfig: {
        type: Array,
        default: () => [],
      },
      //@单选框标识
      radioFlag: { type: Boolean, default: false },
      //@ 多选框标识
      checkBoxFlag: {
        type: Boolean,
        default: false,
      },
      //@ 表格上方左侧按钮参数
      tableLeftBtn: {
        type: Array,
        default: () => [],
      },
      //@ 表格数据
      tableData: {
        type: Array,
        default: () => [],
      },
      //@表头配置
      tableHeader: {
        type: Array,
        default: () => [],
      },
      //@表格按钮
      tableBtn: {
        type: Array,
        default: () => [],
      },
      //@ 分页数量总数
      total: {
        type: Number,
        default: 0,
      },
      tableHeightMinus: {
        type: Number,
        default: 0,
      },
    },
    data() {
      return {
        headerForm: {},
        btnList: [],
        tableBtnList: [],
        flag: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        height: this.$baseTableHeight(),
        checkedKeys: false,
        pageSize: 15,
        currentPage: 1,
        pickerOptions: {},
        tableRadio: {},
      }
    },
    watch: {},
    created() {
      //@ 生成头部区域form表单的v-model
      let _headerForm_ = {}
      for (let i = 0; i < this.formConfig.length; i++) {
        _headerForm_[this.formConfig[i].model] = ''
      }
      let _btnList_ = btnFilter(this.tableLeftBtn)
      let _tableBtnList_ = btnFilter(this.tableBtn)
      this.headerForm = Object.assign({}, _headerForm_)
      this.btnList = Object.assign([], _btnList_)
      this.tableBtnList = Object.assign([], _tableBtnList_)
      this.height = this.$baseTableHeight() - this.tableHeightMinus
    },
    //@ 挂载前监听屏幕自适应高度
    beforeMount() {
      window.addEventListener('resize', () => {
        this.height = this.$baseTableHeight()
      })
    },
    //@ 组件销毁后移除监听
    beforeDestroy() {
      window.removeEventListener('resize', () => {
        this.height = this.$baseTableHeight()
      })
    },
    methods: {
      //@ 表格单选框点击事件
      radioClickChange(data) {
        this.tableRadio = data
        this.$emit('radioClickChange', data)
      },
      //@ 头部搜索区域取值
      headFormSearch() {
        this.$emit('headerFormValue', this.headerForm, true)
      },
      //@ 头部搜索区域清空重置
      headFormReset() {
        for (const key in this.headerForm) {
          this.headerForm[key] = ''
        }
        this.$emit('headerFormValue', this.headerForm, false)
      },
      //@ 工具栏按钮组
      toolsBtn(type) {
        this.$emit('btnTools', type)
      },
      //@ 表格内按钮点击
      rowClick(data, type) {
        this.$emit('rowClick', data, type)
      },
      //@ 双击一行
      rowDBClick(data) {
        this.$emit('rowDBClick', data)
      },
      //@ 单击一行
      rowTapClick(data) {
        this.$emit('rowTapClick', data)
      },
      //@ 表格全选
      selectAll(data) {
        this.checkedKeys = !this.checkedKeys
        if (!this.checkedKeys) {
          this.$refs.multipleTable.clearSelection()
        } else {
          this.splite(data, this.checkedKeys)
        }
        this.$emit('update:checkedList', data)
      },
      //@checkbox单独勾选事件
      selectChange(data, rows) {
        this.$emit('update:checkedList', data)
      },
      //@处理element本身多选不会选中子级的问题
      splite(data, flag) {
        data.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row, flag)
          if (row.children != undefined) {
            this.splite(row.children)
          }
        })
      },
      //@ 页目条数切换
      handleSizeChange(val) {
        this.pageSize = val
        this.$emit('pagination', { pageNum: this.currentPage, limit: val })
      },
      //@ 页码切换
      handleCurrentChange(val) {
        this.currentPage = val
        this.$emit('pagination', { pageNum: val, limit: this.pageSize })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .crud-opts {
    padding: 4px 0;
    display: -webkit-flex;
    display: flex;
    align-items: center;
  }
  .crud-opts .crud-opts-right {
    margin-left: auto;
  }
  ::v-deep {
    // 时间选择器 中间文字部分样式
    .el-range-separator {
      width: 10% !important;
    }
  }
</style>
